import styled from 'styled-components';

export const Container = styled.div`
  .progress-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: #fff;
    padding: 16px;
    margin-bottom: 16px;
  }

  .progress-head {
    display: flex;
    justify-content: space-between;
    color: #21354a;

    strong {
      font-weight: 600;
    }
  }

  .progress-bar-track {
    height: 6px;
    border-radius: 3px;
    background: #e9ecef;
    overflow: hidden;
    margin: 10px 0;

    span {
      height: 100%;
      display: block;
      background: #28a745;
      transition: width 0.3s;
    }
  }

  .progress-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 20px;
    font-size: 13px;

    > span {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .material-icons-outlined {
      font-size: 17px;
    }

    .text-attention {
      color: #856404;
    }
  }

  .checks {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .check-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 16px;
    background: #fff;

    &.failed {
      border-color: #dc3545;
    }

    &.attention {
      border-color: #ffc107;
    }

    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #21354a;
      margin: 8px 0;
    }

    blockquote {
      background: #f8f9fa;
      border-left: 3px solid #dee2e6;
      padding: 10px 12px;
      margin: 0 0 10px;
      font-size: 13px;
      font-style: italic;
      color: #495057;

      small {
        display: block;
        margin-top: 4px;
      }

      .btn-link {
        font-size: 13px;
        font-style: normal;
        display: inline-flex;
        align-items: center;
        gap: 4px;

        .material-icons-outlined {
          font-size: 15px;
        }
      }
    }
  }

  .rule-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: 600;

    .material-icons-outlined {
      font-size: 15px;
    }
  }

  .status-met {
    background: #d4edda;
    color: #155724;
  }

  .status-unmet {
    background: #f8d7da;
    color: #721c24;
  }

  .status-attention {
    background: #fff3cd;
    color: #856404;
  }

  .status-aware {
    background: #e9ecef;
    color: #6c757d;
  }

  .rule-detail {
    margin: 6px 0 10px;
    color: #495057;
  }

  .rule-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
`;
